module.exports = __webpack_public_path__ + "static/img/6.7cacde5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/static/gameImg/online/6.jpg
// module id = 4m/A
// module chunks = 0